/* assets/color-bridge.js */
(function () {
  if (window.__colorBridgeReady) return;
  window.__colorBridgeReady = true;

  const findCard = (el) =>
    el && el.closest && el.closest('[data-product-root], .qa-card, .product-card, product-card');

  // Robust lookup by pid (works even when swatches are rendered outside the card)
  function findCardByPid(pid) {
    if (!pid) return null;
    return (
      document.querySelector(`[data-product-root][data-product-id="${pid}"]`) ||
      document.querySelector(`[data-product-id="${pid}"] [data-product-root]`) ||
      document.querySelector(`.qa-card[data-product-id="${pid}"], .product-card[data-product-id="${pid}"], product-card[data-product-id="${pid}"]`) ||
      null
    );
  }

  function cardForSwatchRoot(swatchRoot) {
    let card = findCard(swatchRoot);
    const pidAttr =
      swatchRoot.getAttribute('data-product-id') ||
      swatchRoot.closest?.('[data-product-id]')?.getAttribute('data-product-id');
    if (!card || (pidAttr && card.getAttribute('data-product-id') !== String(pidAttr))) {
      card = findCardByPid(pidAttr) || card;
    }
    return card;
  }

  const readProductJson = (card) => {
    const sc = card?.querySelector('script[type="application/json"][data-product-json]');
    if (!sc?.textContent) return null;
    try {
      const val = JSON.parse(sc.textContent.trim());
      return (val && typeof val === 'object' && val.variants) ? val : null;
    } catch {}
    return null;
  };

  const colorIndex = (product) => {
    if (!product?.options) return -1;
    const wanted = ['color', 'colour', 'colorway', 'colourway', 'shade', 'print'];
    return product.options.findIndex(o => wanted.includes(String(o).toLowerCase()));
  };

  const getOptionValues = (product, idx) => {
    if (!product?.variants?.length || idx < 0) return [];
    const set = new Set();
    product.variants.forEach(v => {
      const opts = Array.isArray(v.options) ? v.options : [v.option1, v.option2, v.option3];
      const val = opts[idx];
      if (val) set.add(String(val).trim());
    });
    return Array.from(set);
  };

  function extractColorFrom(el) {
    if (!el) return null;
    let cur = el;
    for (let i = 0; cur && i < 6; i++, cur = cur.parentElement) {
      const v =
        cur.getAttribute?.('data-value') ||
        cur.getAttribute?.('data-color') ||
        cur.getAttribute?.('data-colour') ||
        cur.getAttribute?.('aria-label') ||
        cur.getAttribute?.('title');
      if (v && v.trim()) return v.trim();

      const hidden = cur.querySelector?.('.visually-hidden,[aria-hidden="false"]');
      if (hidden?.textContent?.trim()) return hidden.textContent.trim();

      if (cur.tagName === 'INPUT' && /radio|checkbox/i.test(cur.type) && cur.value)
        return cur.value.trim();
    }
    return null;
  }

  function getCheckedSwatchValue(swatchRoot) {
    const checked = swatchRoot.querySelector('input[type="radio"][name*="-swatch"]:checked');
    if (checked?.value) return checked.value.trim();
    if (checked?.getAttribute('aria-label')) return checked.getAttribute('aria-label').trim();
    const selected =
      swatchRoot.querySelector('[aria-pressed="true"],[aria-checked="true"],[aria-selected="true"],.is-selected,.selected,.active');
    return extractColorFrom(selected);
  }

  function normalizeColorForProduct(card, raw) {
    if (!raw) return null;
    const product = readProductJson(card);
    if (!product) return raw;
    const idx = colorIndex(product);
    const values = getOptionValues(product, idx);
    if (!values.length) return raw;

    const lower = raw.toLowerCase();
    let hit = values.find(v => v.toLowerCase() === lower);
    if (hit) return hit;
    hit = values.find(v => v.toLowerCase().includes(lower) || lower.includes(v.toLowerCase()));
    return hit || raw;
  }

  function setColorDatasets(card, color) {
    const inner =
      (card.querySelector && card.querySelector('[data-product-root]')) ||
      (card.closest && card.closest('[data-product-root]')) ||
      card;
    if (inner) inner.dataset.selectedColor = color;

    const outer =
      (inner.closest && inner.closest('product-card, .product-card')) ||
      (card.closest && card.closest('product-card, .product-card')) ||
      card;
    if (outer) outer.dataset.selectedColor = color;

    return inner || outer || card;
  }

  function setColorAndNotify(card, color) {
    if (!card || !color) return;
    const target = setColorDatasets(card, color);

    // persist by pid
    const pid = target?.dataset?.productId;
    if (pid) {
      window.__selectedColors = window.__selectedColors || {};
      window.__selectedColors[pid] = color;
    }

    // bubble so any listener on ancestors gets it
    target.dispatchEvent(new CustomEvent('qa:color-changed', {
      bubbles: true,
      detail: { card: target, color }
    }));
  }

  // React to user interactions
  document.addEventListener('change', function (e) {
    const swatchRoot = e.target.closest('product-swatches[data-swatch-root]');
    if (!swatchRoot) return;
    const card = cardForSwatchRoot(swatchRoot);
    if (!card) return;
    const raw = getCheckedSwatchValue(swatchRoot) || extractColorFrom(e.target);
    const normalized = normalizeColorForProduct(card, raw);
    if (normalized) setColorAndNotify(card, normalized);
  }, true);

  document.addEventListener('click', function (e) {
    const swatchRoot = e.target.closest('product-swatches[data-swatch-root]');
    if (!swatchRoot) return;
    const card = cardForSwatchRoot(swatchRoot);
    if (!card) return;
    setTimeout(() => {
      const raw = getCheckedSwatchValue(swatchRoot) || extractColorFrom(e.target);
      const normalized = normalizeColorForProduct(card, raw);
      if (normalized) setColorAndNotify(card, normalized);
    }, 0);
  }, true);

  // Bootstrap: set initial selected color for every card
  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-swatches[data-swatch-root]').forEach((swatchRoot) => {
      const card = cardForSwatchRoot(swatchRoot);
      if (!card) return;
      const inner = card.closest?.('[data-product-root]') || card;
      if (inner?.dataset?.selectedColor) return;

      const raw = getCheckedSwatchValue(swatchRoot);
      if (!raw) return;
      const normalized = normalizeColorForProduct(inner, raw);
      if (!normalized) return;

      setColorDatasets(inner, normalized);
      inner.dispatchEvent(new CustomEvent('qa:color-changed', {
        bubbles: true,
        detail: { card: inner, color: normalized }
      }));
    });
  });

  console.info('[color-bridge] ready (logs enabled)');
})();










